<template>
  <div class="cs">
    <Tooltip v-for="c in presets" :key="c.label" :text="$t(`dash.overview.dashboards.colors.${c.label}`)" position="top">
      <span
        class="cs-swatch"
        :class="{ active: isActive(c), 'cs-swatch--none': mode === 'background' && !c.key, 'cs-swatch--text': mode !== 'background' }"
        :style="mode === 'background' ? { background: c.color } : { color: c.color }"
        role="button"
        tabindex="0"
        @click="$emit('input', c.key)"
        @keydown.enter="$emit('input', c.key)"
      >
        <template v-if="mode !== 'background'">A</template>
        <i v-else-if="isActive(c)" class="material-icons">check</i>
      </span>
    </Tooltip>
    <!-- Couleur personnalisée : sélecteur natif du navigateur -->
    <Tooltip :text="$t('dash.overview.dashboards.colors.custom')" position="top">
      <label class="cs-swatch cs-swatch--custom" :class="{ active: custom }" :style="custom ? { background: value } : {}">
        <input type="color" :value="pickerValue" @input="$emit('input', $event.target.value)" />
        <i class="material-icons">{{ custom ? 'check' : 'colorize' }}</i>
      </label>
    </Tooltip>
  </div>
</template>

<script>
import Tooltip from '../../tooltip/tooltipInit.vue'
import { resolveColor, isCustomColor } from './widgets/noteColors'

/**
 * Choix d'une couleur : pastilles prédéfinies (clé) ou couleur personnalisée (#rrggbb)
 */
export default {
  name: 'ColorSwatches',

  components: { Tooltip },

  props: {
    value: { type: String, default: null },
    presets: { type: Array, required: true },
    // background : pastille pleine ; text : « A » coloré
    mode: { type: String, default: 'background' }
  },

  computed: {
    custom() {
      return isCustomColor(this.value, this.presets)
    },

    pickerValue() {
      return resolveColor(this.value, this.presets) || (this.mode === 'background' ? '#ffffff' : '#121826')
    }
  },

  methods: {
    isActive(c) {
      if (this.custom) return false
      return (this.value || null) === c.key || (!!this.value && !!c.key && String(this.value).toLowerCase() === c.color.toLowerCase())
    }
  }
}
</script>

<style scoped>
.cs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.cs-swatch {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  overflow: hidden;
  border: 1.5px solid #e0d0ea;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
}
.cs-swatch:hover {
  transform: scale(1.08);
}
.cs-swatch.active {
  border-color: #b64985;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #b64985;
}
.cs-swatch .material-icons {
  font-size: 15px;
  color: #6b1f4d;
}
/* Aucun fond : rond barré */
.cs-swatch--none {
  background: linear-gradient(135deg, #fff 45%, #d93025 45%, #d93025 55%, #fff 55%) !important;
}
.cs-swatch--text {
  font-size: 14px;
  font-weight: 800;
}
/* Personnalisée : arc-en-ciel tant qu'aucune couleur perso n'est choisie */
.cs-swatch--custom {
  background: conic-gradient(#e53935, #fdd835, #43a047, #1e88e5, #8e24aa, #e53935);
}
.cs-swatch--custom .material-icons {
  color: #fff;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
}
.cs-swatch--custom input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
